import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useRef, useState } from 'react'
import { PersonFillExclamation, PersonPlusFill } from 'react-bootstrap-icons'
import Authentication from '../../../libs/api/services/Authentication'
import Questionnaire from '../../../libs/api/services/Questionnaire'
import QuestionnaireAssignment from '../../../libs/api/services/QuestionnaireAssignment'
import Team from '../../../libs/api/services/Team'
import CommonFunctionsContext from '../../common/CommonFunctionsProvider'

export default function UserRequests() {
    const { showError } = useContext(CommonFunctionsContext)
    const [teams, setTeams] = useState([])
    const [loading, isLoading] = useState(true)
    const [questionnaires, setQuestionnnaires] = useState([])
    const _load = async () => {
        const qs = await QuestionnaireAssignment
            .GetQuestionnaireByType("Login - Registration Form", Authentication.getFacility())
        setQuestionnnaires(await Promise.all(qs.slice(5).map(async x =>
            await Questionnaire
                // .GetQuestionnaireResults(QuestionnaireAssignmentId)
                .GetQuestionnaireResultsFull(x.id)
                .catch(e => console.error(e))
        )))
        isLoading(false)
        // .then(async (r) => {
        // setQuestionnnaires(await Promise.all(qs.map(async x =>
        //     await Questionnaire
        //         // .GetQuestionnaireResults(QuestionnaireAssignmentId)
        //         .GetQuestionnaireResultsFull(x.id)
        //         .catch(e => console.error(e))
        // )
        // )
        // )
        // })
    }

    const _loadFacilityTeams = async () => {
        setTeams(await Team.GetFacilitiesTeams().catch(showError))
    }
    useEffect(() => {
        _load()
        _loadFacilityTeams()
    }, [])

    if (loading) return <div className='text-center p-2'>
        <h2>Loading User Requests...</h2>
        <FontAwesomeIcon icon={faSpinner} spin size="2x" />
    </div>

    if (!questionnaires || questionnaires.length === 0) {
        return (
            <div className='text-center p-2'>
                <h2>No User Requests</h2>
                <p>There are no user requests at the moment.</p>
            </div>
        )
    }

    return (
        <div style={{ overflow: 'auto' }} className='p-2'>
            <div className='text-center'>
                <h2>User Requests ({questionnaires.length})</h2>
            </div>
            {
                questionnaires.slice(5).map((q) =>
                    <UserRequestCard key={q.id} questionnaire={q} onComplete={() => _load()} showError={showError} teams={teams} />
                )
            }
        </div>
    )
}


const UserRequestCard = ({ questionnaire, onComplete, showError, teams }) => {
    const [loading, setLoading] = useState(false)
    const [hide, setHidden] = useState(false)
    const selectRef = useRef(null)
    const _handleAccept = (id) => {
        setLoading(true)
        QuestionnaireAssignment
            .AcceptColdRequest(id, selectRef.current.value)
            .then((r) => {
                setHidden(true)
                onComplete()
            }).catch(showError)
    }
    const _handleDecline = (id) => {
        setLoading(true)
        QuestionnaireAssignment
            .DeclineColdRequest(id)
            .then((r) => {
                setHidden(true)
                onComplete()
            }).catch(showError)
    }

    if (hide) return <></>
    if (loading) return <div className='text-center p-2'>
        <h2>Processing Request...</h2>
        <FontAwesomeIcon icon={faSpinner} spin size="2x" />
    </div>
    return <div className='bg-primary-container m-2 p-2 rounded shadow'>
        <div >
            <QuestionnaireResults
                questionnaire={questionnaire}
            />

            <div className='d-flex justify-content-center align-items-center align-content-center'>
                {!teams ?
                    <div>Currently there are no teams available to link this patient to.</div>
                    :
                    <div className='d-flex justify-content-center p-1 rounded bg-secondary-container me-2'>
                        <label>Assign user to team:</label>
                        <select ref={selectRef} className='border-0 rounded bg-transparent text-primary text-center' defaultValue={teams.length > 0 ? teams[0].id : ''}>
                            {teams.map((team) => <option key={team.id} value={team.id}>{team.teamName}</option>)}
                        </select>
                        <button onClick={(e) => _handleAccept(questionnaire.id)} className='btn btn-xs '><PersonPlusFill />Accept</button>
                    </div>
                }
                <button onClick={(e) => _handleDecline(questionnaire.id)} className='btn '><PersonFillExclamation />Decline Request</button>

            </div>
        </div>
    </div>
}

function QuestionnaireResults({ questionnaire }) {

    // If JSON make nicer
    const formatResponse = (data) => {
        if (data.startsWith('{') && data.endsWith('}')) {
            try {
                const json = JSON.parse(data);
                return Object.keys(json).includes('option') ? json.option : JSON.stringify(json, null, 2);
            } catch (e) {
                console.error("Failed to parse JSON:", e);
            }
        }
        return data;
    }

    // Function to map questions to their answers
    const mapQuestionsToAnswers = () => {
        const questionAnswerMap = [];

        // Ensure the questionnaire structure is valid
        const sections = questionnaire.questionnaire?.resource?.resource?.sections;
        const responses = questionnaire?.responses;
        if (!sections || !Array.isArray(sections) || !responses || !Array.isArray(responses)) {
            console.error("Invalid questionnaire structure");
            return questionAnswerMap;
        }

        // Iterate through sections in the questionnaire
        sections.forEach((section) => {
            if (section.components && Array.isArray(section.components)) {
                section.components.forEach((component) => {
                    // Extract the question from the component properties
                    const question = component.properties?.find(
                        (prop) => prop.property === 'Question'
                    )?.values;

                    // Find the corresponding response for the component
                    const response = responses.find(
                        (res) => res.answerType.id === component.id
                    );

                    // Add the question and answer to the map
                    if (question && response) {
                        questionAnswerMap.push({
                            question,
                            answer: response.answer,
                        });
                    }
                });
            }
        });
        return questionAnswerMap;
    };
    const questionAnswerMap = mapQuestionsToAnswers();

    return (
        <div>
            <h3>User Request Details</h3>
            {questionAnswerMap.length > 0 ? (
                <ul>
                    {questionAnswerMap.map((qa, index) => (
                        <li key={index}>
                            <strong>{qa.question}</strong>: {formatResponse(qa.answer)}
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No questions or answers found.</p>
            )}
        </div>
    );
}
